import React from "react"

export default ({ isDisplayStatus, status }) => (
  <div className="profile__grid profile__grid--02">
    {(isDisplayStatus) ? (<i className={`profile__lamp profile__lamp--${status}`} ></i>) : ''}
  </div>
)
